import type { RouteRecordRaw } from 'vue-router';
import { allServices } from '@/pages/services/route';

export const serviceRoutes: RouteRecordRaw = {
    path: '/service',
    component: () => import('@/layouts/main.vue'),
    meta: {
        requireAuth: true,
        requireStoreId: true,
    },
    children: [
        ...allServices,
    ],
};

